// import { LoadingButton } from '@mui/lab'
// import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
// import { ExplanationAccordion } from 'components'
// import { VehicleRecallDto } from 'dtos'
// import { VehicleRecallNoteDto, VehicleRecallNoteValidationSchema } from 'dtos/vehicleRecallNoteDto'
// import { Formik } from 'formik'
// import { useEffect, useState } from 'react'
// import * as controllers from 'controllers'
// import { VehicleRecallParameters } from 'parameters'

// interface RecallNoteAddEditDialogProps {
//   initialValues: VehicleRecallNoteDto
//   isLoading: boolean
//   onClose: () => void
//   onSave: (values: VehicleRecallNoteDto) => void
//   open: boolean
//   vehicleGuid: string
//   parameters: VehicleRecallParameters
// }

// export default function RecallNoteAddEditDialog({
//   initialValues,
//   isLoading,
//   onClose,
//   onSave,
//   open,
//   vehicleGuid,
//   parameters
// }: RecallNoteAddEditDialogProps) {
//   const [recallCampaigns, setRecallCampaigns] = useState<VehicleRecallDto[]>([])

//   useEffect(() => {
//     controllers
//       .getVehicleRecallCampaigns(vehicleGuid, parameters)
//       .then(response => setRecallCampaigns(response.value))
//       .catch(console.error)
//   }, [vehicleGuid, parameters])

//   console.log(recallCampaigns)

//   return (
//     <Dialog open={open}>
//       <Formik
//         enableReinitialize
//         initialValues={initialValues}
//         onSubmit={(values, formikHelpers) => {
//           onSave(values)
//           formikHelpers.setSubmitting(false)
//         }}
//         validateOnBlur
//         validateOnChange
//         validationSchema={VehicleRecallNoteValidationSchema}
//       >
//         {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
//           return (
//             <form onSubmit={handleSubmit}>
//               <DialogContent>
//                 <Grid container spacing={2} alignItems='center'>
//                   <DialogTitle>Add Recall Note</DialogTitle>

//                   <Grid item xs={12}>
//                     <Autocomplete
//                       options={recallCampaigns}
//                       getOptionLabel={(option: VehicleRecallDto) => (option.recallCampaignId ?? '').toString()}
//                       onChange={(_e, value: VehicleRecallDto | null) => {
//                         setFieldValue('recallCampaignId', value ? value.recallCampaignId : '')
//                       }}
//                       renderInput={params => (
//                         <TextField
//                           {...params}
//                           label='Recall Campaign ID'
//                           error={Boolean(touched.recallCampaignId && errors.recallCampaignId)}
//                           helperText={touched.recallCampaignId && errors.recallCampaignId}
//                         />
//                       )}
//                       value={
//                         recallCampaigns.find(
//                           campaign => campaign.recallCampaignId === values.vehicleRecall?.recallCampaignId
//                         ) || null
//                       }
//                     />
//                   </Grid>

//                   {/* <Grid item xs={12}>
//                     <Autocomplete
//                       options={recallCampaigns}
//                       getOptionLabel={(option: VehicleRecallDto) => (option.recallCampaignId ?? '').toString()}
//                       onChange={(_e, value: VehicleRecallDto | null) => {
//                         setFieldValue('recallCampaignId', value ? value.recallCampaignId : '') // Ensure this is set correctly
//                       }}
//                       renderInput={params => (
//                         <TextField
//                           {...params}
//                           label='Recall Campaign ID'
//                           error={Boolean(touched.recallCampaignId && errors.recallCampaignId)}
//                           helperText={touched.recallCampaignId && errors.recallCampaignId}
//                         />
//                       )}
//                       value={
//                         recallCampaigns.find(
//                           campaign => campaign.recallCampaignId === values.vehicleRecall?.recallCampaignId
//                         ) || null
//                       }
//                     />
//                   </Grid> */}

//                   <Grid item xs={12}>
//                     <TextField
//                       disabled={isLoading || isSubmitting}
//                       error={Boolean(touched.note && errors.note)}
//                       helperText={touched.note && touched.note}
//                       label='Recall Note'
//                       maxRows={4}
//                       minRows={4}
//                       multiline
//                       name='note'
//                       onBlur={handleBlur}
//                       onChange={handleChange}
//                       value={values.note}
//                     />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <ExplanationAccordion variant='outlined'>
//                       || When creating a Note, “Recall Campaign ID” is not required, but Note is required. ||
//                     </ExplanationAccordion>
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//               <DialogActions>
//                 <Button color='inherit' onClick={onClose} variant='text'>
//                   CANCEL
//                 </Button>

//                 <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
//                   SAVE
//                 </LoadingButton>
//               </DialogActions>
//             </form>
//           )
//         }}
//       </Formik>
//     </Dialog>
//   )
// }

import { LoadingButton } from '@mui/lab'
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { VehicleRecallDto } from 'dtos'
import { VehicleRecallNoteDto, VehicleRecallNoteValidationSchema } from 'dtos/vehicleRecallNoteDto'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { getVehicleRecallCampaigns } from 'controllers/vehicles' // Import the function
import { VehicleRecallParameters } from 'parameters'

interface RecallNoteAddEditDialogProps {
  initialValues: VehicleRecallNoteDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: VehicleRecallNoteDto) => void
  open: boolean
  vehicleGuid: string // Add vehicleGuid as a prop
  parameters: VehicleRecallParameters // Add parameters as a prop
}

export default function RecallNoteAddEditDialog({
  initialValues,
  isLoading,
  onClose,
  onSave,
  open,
  vehicleGuid,
  parameters
}: RecallNoteAddEditDialogProps) {
  const [recallCampaigns, setRecallCampaigns] = useState<VehicleRecallDto[]>([])

  // Display the Recall Campaign Ids from each page in the recall campaigns table since its paginated to 5
  const fetchAllRecallCampaigns = async () => {
    try {
      let allRecallCampaigns: VehicleRecallDto[] = []
      let currentPage = 0
      let hasMorePages = true

      while (hasMorePages) {
        const response = await getVehicleRecallCampaigns(vehicleGuid, {
          ...parameters,
          page: currentPage
        })

        if (response?.value?.length) {
          allRecallCampaigns = [...allRecallCampaigns, ...response.value]
          currentPage++
        } else {
          hasMorePages = false
        }
      }

      setRecallCampaigns(allRecallCampaigns)
    } catch (error) {
      console.error('Failed to fetch all recall campaigns', error)
    }
  }

  useEffect(() => {
    if (open) {
      fetchAllRecallCampaigns()
    }
  }, [open, vehicleGuid, parameters])

  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
          fetchAllRecallCampaigns()
        }}
        validateOnBlur
        validateOnChange
        validationSchema={VehicleRecallNoteValidationSchema}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Add Recall Note</DialogTitle>

                  <Grid item xs={12}>
                    <Autocomplete
                      options={recallCampaigns}
                      getOptionLabel={(option: VehicleRecallDto) => (option.recallCampaignId ?? '').toString()}
                      onChange={(_e, value: VehicleRecallDto | null) => {
                        setFieldValue('vehicleRecall', value)
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          label='Recall Campaign ID'
                          error={Boolean(touched.vehicleRecall && errors.vehicleRecall)}
                          helperText={touched.vehicleRecall && errors.vehicleRecall}
                        />
                      )}
                      value={
                        recallCampaigns.find(
                          campaign => campaign.recallCampaignId === values.vehicleRecall?.recallCampaignId
                        ) || null
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.note && errors.note)}
                      helperText={touched.note && errors.note}
                      label='Recall Note'
                      maxRows={4}
                      minRows={4}
                      multiline
                      name='note'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.note}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>
                      || When creating a Note, “Recall Campaign ID” is not required, but Note is required. ||
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
